/**
 * Constants for chat/inbox functionality
 */
export const CHAT_CONSTANTS = {
	// Pagination
	MESSAGE_LIMIT: 50,
	CHAT_LIST_LIMIT: 100,

	// Polling intervals (in milliseconds)
	POLLING_INTERVAL: 5000, // 5 seconds

	// Scroll behavior
	AUTO_SCROLL_DELAY: 100, // milliseconds
	SCROLL_THRESHOLD: 100, // pixels from top/bottom to trigger actions
	SCROLL_DEBOUNCE_DELAY: 150, // milliseconds

	// File upload
	MAX_FILE_SIZE_BYTES: 10 * 1024 * 1024, // 10MB
} as const;

